import { render, staticRenderFns } from "./commonRuleView.vue?vue&type=template&id=7796229c&"
import script from "./commonRuleView.vue?vue&type=script&lang=js&"
export * from "./commonRuleView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports